let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b2yZA")).then(() => parcelRequire('lp0fk'));